export interface ImageAsset {
  src: string
  alt: string
  title: string
  description: string
}

export const imageAssets = {
  homeHero: {
    src: '/images/home/hero-main.png',
    alt: 'Rez-Hub hero image showing a premium institutional environment connected to land and governance.',
    title: 'Home Hero Image',
    description: 'Primary homepage visual for Rez-Hub by Yethirihwanonhase.',
  },
  systemsDiagram: {
    src: '/images/platform/systems-hero.png',
    alt: 'Modular systems diagram showing the Rez-Hub platform structure.',
    title: 'Systems Diagram',
    description: 'Editorial systems map showing messaging, files, identity, governance, and supporting modules.',
  },
  platformHero: {
    src: '/images/platform/platform-hero.png',
    alt: 'Rez-Hub platform image showing a secure and modern sovereign digital environment.',
    title: 'Platform Hero Image',
    description: 'Platform overview visual for the Rez-Hub product environment.',
  },
  carmenPortrait: {
    src: '/images/about/carmen_miller_profile.jpg',
    alt: 'Portrait of Carmen Miller, Partner at Yethirihwanonhase.',
    title: 'Carmen Miller Portrait',
    description: 'Partner portrait for Carmen Miller.',
  },
  carolinePortrait: {
    src: '/images/about/caroline-headshot-840x811.jpg',
    alt: 'Portrait of Caroline Van Every-Albert, Partner at Yethirihwanonhase.',
    title: 'Caroline Van Every-Albert Portrait',
    description: 'Partner portrait for Caroline Van Every-Albert.',
  },
  jeseePortrait: {
    src: '/images/about/Jesee_profile.jpeg',
    alt: 'Portrait of Jesee Williams, Partner at Yethirihwanonhase.',
    title: 'Jesee Williams Portrait',
    description: 'Partner portrait for Jesee Williams.',
  },
  keatonPortrait: {
    src: '/images/about/Keaton_profile.jpeg',
    alt: 'Portrait of Keaton Williams, Partner at Yethirihwanonhase.',
    title: 'Keaton Williams Portrait',
    description: 'Partner portrait for Keaton Williams.',
  },
  resources: {
    src: '/images/resources/resources-library.png',
    alt: 'Editorial still life of governance documents and digital readiness materials.',
    title: 'Resources Image',
    description: 'Supports the Resources page and download library framing.',
  },
} satisfies Record<string, ImageAsset>

export type ImageAssetKey = keyof typeof imageAssets
